import React from 'react';
import { Typography, Box } from '@mui/material';

const PlanNameBadge = ({ plan,name, size = 'small' }) => {
  const getPlanColor = (plan) => {
    const colors = {
      free: '#6c757d', // Gray
      basic: '#007bff', // Blue
      advance: '#6f42c1', // Purple
    };
    return colors[plan?.toLowerCase()] || '#6c757d';
  };

  const getPlanLabel = (plan) => {
    const planLower = plan?.toLowerCase();
    if (planLower === 'basic') {
      return 'Basic Plan';
    }
    return `${plan}`;
  };

  const planColor = getPlanColor(plan);

  return (
    <Typography 
      variant="body2" 
      fontWeight="bold" 
      sx={{ color: planColor }}
    >
      {name}
    </Typography>
  );
};

export default PlanNameBadge; 